const isDevelopment = process.env.NODE_ENV === "development";
const API_URL = isDevelopment ? "http://localhost:3002/api" : "/api";

export const getRecentActivity = async () => {
  const response = await fetch(`${API_URL}/activity/recent`);
  if (!response.ok) {
    throw new Error("Failed to fetch recent activity");
  }
  return response.json();
};
